module.exports = __webpack_public_path__ + "img/542dca4.png";